import { z } from 'zod';
import { ErrorCode } from '../../shared/error-codes';
import { EntitySuggestionSchema } from '../../entities/entity-suggestion';
/**
 * Link an existing **pending** suggestion to a recording — the manual
 * counterpart to the AI dedup's auto-adopt. The caller writes the suggestion
 * ref into the originating slot client-side; this endpoint maintains the
 * server-managed `entitySuggestions[]` denormalization (`$addToSet`) so the
 * adoption counts toward shadow-system occurrence tallies and shows up in the
 * recording's picker ghost list.
 */ export const LinkEntitySuggestionRequestSchema = z.object({
    recordingId: z.string().min(1, ErrorCode.FIELD_REQUIRED)
});
export const LinkEntitySuggestionResponseSchema = z.object({
    data: EntitySuggestionSchema
});

//# sourceMappingURL=link-entity-suggestion.contract.js.map